import { inactiveUsersTypes } from './actionTypes';

const INIT_STATE = {
  inactiveUsers: [],
  inactiveUsersUpdate: {},
  isLoading: false,
  error: {},
};

const InactiveUsersReduce = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case inactiveUsersTypes.GET_INACTIVE_USERS:
      return {
        ...state,
        isLoading: true,
      };
    case inactiveUsersTypes.GET_INACTIVE_USERS_SUCCESS:
      return {
        ...state,
        inactiveUsers: action.payload,
        isLoading: false,
      };

    case inactiveUsersTypes.GET_INACTIVE_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    //UPDATE USER active
    case inactiveUsersTypes.ACTIVE_USER:
      state = {
        ...state,
      };
      break;
    case inactiveUsersTypes.ACTIVE_USER_SUCCESS:
      return {
        ...state,
        inactiveUsersUpdate: action.payload,
        isLoading: false,
      };

    case inactiveUsersTypes.ACTIVE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    default:
      break;
  }
  return state;
};

export default InactiveUsersReduce;
